"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudeContext = exports.useCrude = void 0;
var react_1 = __importStar(require("react"));
var redux_1 = require("redux");
var react_redux_1 = require("react-redux");
var AppPage_1 = __importDefault(require("./AppPage"));
var actions_exposed_1 = require("./store/actions.exposed");
var version_1 = __importDefault(require("./version"));
var crudeRoot_reducer_1 = require("./store/crudeRoot.reducer");
exports.useCrude = function (props) {
    var crudeHookStore = redux_1.createStore(crudeRoot_reducer_1.crudeRootReducer);
    var dispatch = crudeHookStore.dispatch;
    var _a = react_1.useState(crudeHookStore.getState()), storeState = _a[0], setStoreState = _a[1];
    var crudeMethods = {
        resetTableState: function () { return dispatch(actions_exposed_1.resetTable()); },
        changeLanguage: function (language) { return dispatch(actions_exposed_1.changeLanguage(language)); },
        updateExposedStoreState: function () { return setStoreState(crudeHookStore.getState()); },
    };
    var Crude = function (props) {
        return (react_1.default.createElement(exports.CrudeContext.Consumer, null, function (crudeProps) {
            var config = __assign(__assign({}, crudeProps.crudeHookProps.appPageProps), props.crudeConfig);
            return (react_1.default.createElement(react_redux_1.Provider, { store: crudeHookStore }, !!config && react_1.default.createElement(AppPage_1.default, { crudeConfig: config })));
        }));
    };
    return {
        Crude: Crude,
        crudeHookProps: props,
        methods: crudeMethods,
        storeState: storeState,
        version: version_1.default,
    };
};
exports.CrudeContext = react_1.createContext({});
